import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { FlexRow } from '../../../components/LayoutBoxes';
import { EXIT_ACTIONS, ExitConfirmData } from '../../../stores/dialogStore';
import { dialogStyles as styles } from '../styles/dialogStyles';
import { BaseDialog } from './BaseDialog';

interface ExitConfirmDialogProps {
  data?: ExitConfirmData;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ExitConfirmDialog: FC<ExitConfirmDialogProps> = ({
  data,
  onConfirm,
  onCancel,
}) => {
  const action = data?.action || EXIT_ACTIONS.CLOSE;

  const handleMainAction = () => {
    onConfirm();
  };

  return (
    <BaseDialog open={true} onClose={onCancel} showCloseButton={false}>
      <Box sx={styles.exitContainer}>
        <Typography variant='dialogTitle' component='h2' sx={styles.exitTitle}>
          {action === EXIT_ACTIONS.LOGOUT ? 'Sign out?' : 'Close?'}
        </Typography>

        <Typography variant='dialogBody' component='p' sx={styles.exitSubtitle}>
          Your recording will be saved
        </Typography>

        <FlexRow sx={styles.exitButtonContainer}>
          <Button
            onClick={onCancel}
            variant='outlined'
            size='small'
            fullWidth
            sx={styles.exitActionButton}
          >
            Cancel
          </Button>

          <Button
            onClick={handleMainAction}
            variant='contained'
            size='small'
            fullWidth
            sx={styles.exitActionButton}
          >
            {action === EXIT_ACTIONS.LOGOUT ? 'Sign Out' : 'Close'}
          </Button>
        </FlexRow>
      </Box>
    </BaseDialog>
  );
};
